export default __webpack_public_path__ + "static/media/arequipa-colca_canyon_firecamp.981dfa45.jpg";